import { render } from "./QuestionMaker.vue?vue&type=template&id=3649f871&scoped=true"
import script from "./QuestionMaker.vue?vue&type=script&lang=js"
export * from "./QuestionMaker.vue?vue&type=script&lang=js"

import "./QuestionMaker.vue?vue&type=style&index=0&id=3649f871&scoped=true&lang=css"

import exportComponent from "/tmp/pelican-managers-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3649f871"]])

export default __exports__